<template>
  <div class="d-flex flex-column pa-4">
    <div :class="['d-flex flex-row justify-space-between gap-4']">
      <slot
        name="checkbox"
        :selected="modelValue.selected"
        :update-selected="(e) => (modelValue.selected = e)"
        :label="modelValue.customMedicine"
        :update-label="(e) => (modelValue.customMedicine = e)"
      >
        <v-checkbox
          :label="title"
          v-model="modelValue.selected"
          hide-details
          color="primary"
          dense
          class="ma-0 pa-0 font-size-14"
        />
      </slot>
      <radio-group-component
        v-if="modelValue.selected && simplified"
        v-model="modelValue.simplePeriod"
        :options="{ 'Tratamento prévio': 'previous', 'Tratamento atual': 'current' }"
        :rules="[$validation.required()]"
      />
    </div>
    <v-expand-transition v-if="!simplified">
      <div v-if="modelValue.selected && (medicine == 'other' ? modelValue.customMedicine.trim().length : true)">
        <div class="pl-4 pt-4">
          <previous-treatment-period v-model="modelValue.fullPeriod" :dosageUnit="treatmentOptions.dosageUnit" />
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import { cloneDeep, isEmpty } from 'lodash'
import PreviousTreatmentPeriod from './PreviousTreatmentPeriod.vue'

import { Computed } from '@/_typedefs'
import { PropOptions, WatchOptionsWithHandler } from 'vue'
import { FullPeriod } from './PreviousTreatmentPeriod.vue'
import { createNamespacedHelpers } from 'vuex'
import RadioGroupComponent from '@/components/NewAttendanceForm/Questions/Basic/Radio/RadioGroup.component.vue'

const { mapGetters: newAttendanceFormGetters } = createNamespacedHelpers('newAttendanceForm')

/**
 * @typedef {Record<string, object>} PreviousTreatmentMedicineQuestions
 */

/**
 * @typedef {Object} PreviousTreatmentMedicineValue
 * @property {boolean} selected
 * @property {string} [simplePeriod]
 * @property {FullPeriod} [fullPeriod]
 * @property {string} customMedicine
 */

/** @typedef {PreviousTreatmentMedicineValue} ModelValue */

export default {
  components: {
    PreviousTreatmentPeriod,
    RadioGroupComponent,
  },
  name: 'PreviousTreatmentMedicineParcial',
  props: {
    /** @type {PropOptions<ModelValue>} */
    value: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    medicine: {
      type: String,
      required: true,
    },
    /** @type {PropOptions<{dosageUnit?: string}>} */
    treatmentOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    /** @type {ModelValue} */
    const baseValue = {
      selected: false,
      simplePeriod: 'current',
      fullPeriod: {},
      customMedicine: '',
    }

    /** @type {ModelValue} */
    const modelValue = isEmpty(this.value) ? baseValue : cloneDeep({ ...this.value, selected: true })

    return {
      modelValue,
    }
  },
  computed: {
    .../** @type {{simplified: Computed<boolean>}} */ (newAttendanceFormGetters(['simplified'])),
  },
  watch: {
    /** @type {WatchOptionsWithHandler<ModelValue>} */
    modelValue: {
      handler(val) {
        if (!val.selected) {
          this.$emit('input', null)
          return
        }

        this.$emit('input', { ...val, selected: undefined })
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style scoped>
:deep(.v-label) {
  font-size: 14px;
}
:deep(input) {
  font-size: 14px;
}
:deep(.v-label--active) {
  transform: translateY(-10px) scale(0.85) !important;
}
</style>
